import { useTranslation } from 'react-i18next'
import LandingDevStepsItemLeft from "./LandingDevStepsItemLeft"
import LandingDevStepsItemRight from "./LandingDevStepsItemRight"
import connect from '../../../assets/images/steps/connect.svg'
import mockup from '../../../assets/images/steps/mockup.svg'
import feedback from '../../../assets/images/steps/feedback.svg'
import develop from '../../../assets/images/steps/develop.svg'
import test from '../../../assets/images/steps/test.svg'
import deliver from '../../../assets/images/steps/deliver.svg'

const LandingDevSteps = () => {
    const { t } = useTranslation()

    return (
        <div className="mb-20">
             <p className="font-semibold px-10 mt-10">{ t('devsteps') }</p>

            <div className="hidden sm:block md:block lg:block xl:block">
                <div className="border-b-2 border-dotted border-gray-300 w-full h-10 mx-auto my-10 relative">
                    <div className="border-4 mx-auto my-10 w-10 h-10 rounded-full absolute -inset-y-2/4 left-step-1"></div>
                    <div className="border-4 mx-auto my-10 w-10 h-10 rounded-full absolute -inset-y-2/4 left-step-2"></div>
                    <div className="border-4 mx-auto my-10 w-10 h-10 rounded-full absolute -inset-y-2/4 left-step-3"></div>
                    <div className="border-4 mx-auto my-10 w-10 h-10 rounded-full absolute -inset-y-2/4 left-step-4"></div>
                    <div className="border-4 mx-auto my-10 w-10 h-10 rounded-full absolute -inset-y-2/4 left-step-5"></div>
                    <div className="border-4 mx-auto my-10 w-10 h-10 rounded-full absolute -inset-y-2/4 left-step-6"></div>
                </div>
            </div>

            <div>
                <LandingDevStepsItemLeft number={'01'} title={ t('n1_title') } description={ t('n1_description') } icon={connect}/>
                <LandingDevStepsItemRight number={'02'} title={ t('n2_title') } description={ t('n2_description') } icon={mockup}/>
                <LandingDevStepsItemLeft number={'03'} title={ t('n3_title') } description={ t('n3_description') } icon={feedback}/>
                <LandingDevStepsItemRight number={'04'} title={ t('n4_title') } description={ t('n4_description') } icon={develop}/>
                <LandingDevStepsItemLeft number={'05'} title={ t('n5_title') } description={ t('n5_description') } icon={test}/>
                <LandingDevStepsItemRight number={'06'} title={ t('n6_title') } description={ t('n6_description') } icon={deliver}/>
            </div>
        </div>
    )
}

export default LandingDevSteps